import React from "react";
import { CheckCircle2, Clock, AlertCircle } from "lucide-react";
import { symbolFor } from "@/lib/format";

const META = {
  paid: { label: "Paid", Icon: CheckCircle2, cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  due_soon: { label: "Due soon", Icon: Clock, cls: "bg-amber-100 text-amber-800 border-amber-200" },
  overdue: { label: "Overdue", Icon: AlertCircle, cls: "bg-red-100 text-red-800 border-red-200" },
  outstanding: { label: "Outstanding", Icon: null, cls: "bg-slate-100 text-slate-700 border-slate-200" },
};

export default function StatusBadge({ status, currency = "NGN", className = "", testId }) {
  const m = META[status] || META.outstanding;
  const { Icon } = m;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${m.cls} ${className}`}
    >
      {Icon ? (
        <Icon className="h-3.5 w-3.5" strokeWidth={2.5} />
      ) : (
        <span className="text-xs font-bold leading-none" aria-hidden="true">{symbolFor(currency)}</span>
      )}
      {m.label}
    </span>
  );
}

export function AckBadge({ status }) {
  if (status === "acknowledged")
    return (
      <span className="inline-flex items-center gap-1 rounded-full border border-emerald-200 bg-emerald-50 px-2.5 py-0.5 text-xs font-semibold text-emerald-800">
        <CheckCircle2 className="h-3.5 w-3.5" strokeWidth={2.5} /> Acknowledged
      </span>
    );
  if (status === "disputed")
    return (
      <span className="inline-flex items-center gap-1 rounded-full border border-amber-200 bg-amber-50 px-2.5 py-0.5 text-xs font-semibold text-amber-800">
        <AlertCircle className="h-3.5 w-3.5" strokeWidth={2.5} /> Details questioned
      </span>
    );
  if (status === "requested")
    return (
      <span className="inline-flex items-center gap-1 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-0.5 text-xs font-semibold text-slate-600">
        <Clock className="h-3.5 w-3.5" strokeWidth={2.5} /> Awaiting response
      </span>
    );
  return (
    <span className="inline-flex items-center gap-1 rounded-full border border-slate-200 bg-white px-2.5 py-0.5 text-xs font-medium text-slate-500">
      Not acknowledged
    </span>
  );
}
